/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Import_ButtonInputs */

const en_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Media`)
};

const fr_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer des médias`)
};

const de_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importmedien`)
};

const it_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa Media`)
};

const ru_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов`)
};

const es_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar medios`)
};

const zh_cn2_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口媒体`)
};

const ja_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入メディア`)
};

const hi_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात मीडिया`)
};

const pt_pt2_media_tab_import_button = /** @type {(inputs: Media_Tab_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar mídia`)
};

/**
* | output |
* | --- |
* | "Import Media" |
*
* @param {Media_Tab_Import_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_import_button = /** @type {((inputs?: Media_Tab_Import_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Import_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_import_button(inputs)
	if (locale === "de") return de_media_tab_import_button(inputs)
	if (locale === "it") return it_media_tab_import_button(inputs)
	if (locale === "ru") return ru_media_tab_import_button(inputs)
	if (locale === "es") return es_media_tab_import_button(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_import_button(inputs)
	if (locale === "ja") return ja_media_tab_import_button(inputs)
	if (locale === "hi") return hi_media_tab_import_button(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_import_button(inputs)
	return en_media_tab_import_button(inputs)
});